import { Grid2 } from "@mui/material";
import { ScoreOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { SummaryBlockScoreOverview } from "./SummaryBlockScoreOverview";
import { URLHandler } from "src/services/URLHandler";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { getSsqDisplayTitle } from "src/utils/ssqTitle";
import { ScoreService } from "src/services/ScoreService";
import { getSubscoreOfDisplayModeFromScoreOverview } from "src/utils/scores.ts";

type ScoresBodyOverviewProps = {
    scoreOverview: ScoreOverview;
    doesPostExist?: boolean;
};
export const ScoresBodyOverview = (props: ScoresBodyOverviewProps) => {
    const { scoreOverview } = props;

    const { currentCampaign } = useFoodpilotContext();
    const { company } = useCompanyMetadata();

    if (!scoreOverview || !scoreOverview.ssq) {
        console.warn("ScoresBodyOverview: scoreOverview or scoreOverview.ssq is undefined", { scoreOverview });
        return null;
    }

    // If a subscore exists, display it instead of the unit
    const scores = scoreOverview.values;
    const selectedScore = scores?.[scoreOverview.id] ?? null;
    const _gradeSubscore = getSubscoreOfDisplayModeFromScoreOverview(
        // idk how to solve this.
        selectedScore as any,
        "grade",
    );

    const gradeSubscoreValue = _gradeSubscore?.score.value;
    const diagnosticSubscore =
        gradeSubscoreValue ?
            ScoreService.extractScoreValue(
                // idk how to solve this.
                gradeSubscoreValue as any,
                scoreOverview.displayMode,
            )
        :   undefined;

    const unitOrSubscore =
        diagnosticSubscore !== null && diagnosticSubscore !== undefined ?
            ` / ${diagnosticSubscore}`
        :   scoreOverview.unit;

    // same idk how to solve this
    const scoreValue = (selectedScore?.score as any)?.value ?? null;
    return (
        <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <SummaryBlockScoreOverview
                title={{
                    label: scoreOverview.title,
                    tag: !scoreOverview.isComplete ? "incomplete" : undefined,
                }}
                score={{
                    id: scoreOverview.id,
                    // same idk how to solve this
                    value: scoreValue,
                    unit: unitOrSubscore,
                }}
                selectedScore={selectedScore}
                questionnaireTitle={getSsqDisplayTitle(scoreOverview.ssq)}
                link={URLHandler.company.ssqScore(
                    company.id,
                    scoreOverview.ssq.id,
                    currentCampaign?.id ?? -99,
                    scoreOverview.id,
                )}
                questionnaireLink={URLHandler.company.questionnaireScore(
                    company.id,
                    scoreOverview.ssq.id,
                    currentCampaign?.id ?? -99,
                    scoreOverview.id.toString(),
                )}
                doesPostExist={props.doesPostExist}
            />
        </Grid2>
    );
};
